import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { toast } from "react-toastify";
import DialogTitle from "@mui/material/DialogTitle";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { MdOutlineFileUpload } from "react-icons/md";
import WallpaperIcon from "@mui/icons-material/Wallpaper";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import { useLanguageContext } from "../../Context/LanguageContext";
import { DialogContentText, Typography } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import EquipmentActions from "../../Actions/EquipmentActions";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import { useEffect } from "react";
import TabsActions from "../../Actions/TabsActions";
import tabsStore from "../../Stores/TabsStore";
import tabsConstants from "../../Constants/TabsConstants";

export default function ImageListView({
  isOpen,
  imageData,
  setShowImageListView,
  setShowFileUploadDialog,
  handleLightBox,
  updateImages,
}) {
  const [open, setOpen] = React.useState(isOpen);
  const [openConfirmationAlert, setOpenConfirmationAlert] =
    React.useState(false);
  const [fullWidth, setFullWidth] = React.useState(true);
  const [currentSelectedImageId, setCurrentSelectedImageId] = useState("");
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setShowImageListView(false);
  };

  const handleAlertClose = () => {
    setOpenConfirmationAlert(false);
  };

  const handleAlertOk = () => {
    setOpenConfirmationAlert(false);
    updateImages(currentSelectedImageId);
  };

  const setAsDefaultImage = (id) => {
    setGlobalSpinner(true);
    EquipmentActions.setDefaultEquipmentImage(id);
  };

  const handleShow = (item) => {
    setGlobalSpinner(true);
    TabsActions.getDocumentAsByte(item.id, item.name);
  };

  useEffect(() => {
    function downloadDocumentSuccess() {
      var _details = tabsStore.getResult();
      setGlobalSpinner(false);
    }

    function downloadDocumentFailure() {
      var res = tabsStore.getResult();
      setGlobalSpinner(false);
      toast.error(res);
    }

    tabsStore.addChangeListener(
      tabsConstants.GET_DOCUMENTASBYTE_SUCCESS,
      downloadDocumentSuccess
    );

    tabsStore.addChangeListener(
      tabsConstants.GET_DOCUMENTASBYTE_FAILURE,
      downloadDocumentFailure
    );

    return () => {
      tabsStore.removeChangeListener(
        tabsConstants.GET_DOCUMENTASBYTE_SUCCESS,
        downloadDocumentSuccess
      );

      tabsStore.removeChangeListener(
        tabsConstants.GET_DOCUMENTASBYTE_FAILURE,
        downloadDocumentFailure
      );
    };
  }, []);

  function BasicTable() {
    return (
      <TableContainer component={Paper}>
        <Table
          sx={{ minWidth: 650 }}
          aria-label="simple table"
          className="simpleListTable"
        >
          <TableHead>
            <TableRow>
              <TableCell>{localization.preview}</TableCell>
              <TableCell align="left">{localization.name}</TableCell>
              <TableCell align="left">{localization.actions}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {imageData.map((row, index) => (
              <TableRow
                key={row.name}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="left">
                  <img
                    src={"data:image/jpg;base64," + row.documentAsString}
                    alt={""}
                    className="thumbnailPreview"
                    loading="lazy"
                    style={{ width: "100px" }}
                    onClick={(e) => handleLightBox(e, index)}
                  />
                </TableCell>
                <TableCell align="left">{row.name}</TableCell>
                <TableCell align="left">
                  {!row.isDefualt ? (
                    <Tooltip title={localization.setAsDefaultImage}>
                      <WallpaperIcon
                        className="generalIconCls mr-3"
                        onClick={() => {
                          setAsDefaultImage(row.id);
                        }}
                      />
                    </Tooltip>
                  ) : (
                    <span className="mr-5"></span>
                  )}
                  <Tooltip title={localization.download}>
                    <CloudDownloadOutlinedIcon
                      className="generalIconCls mr-3"
                      onClick={() => {
                        handleShow(row);
                      }}
                    />
                  </Tooltip>

                  <Tooltip title={localization.delete}>
                    <DeleteOutlineIcon
                      className="deleteImgIconCls"
                      onClick={() => {
                        setCurrentSelectedImageId(row.id);
                        if (row.isDefualt) {
                          setOpenConfirmationAlert(true);
                        } else {
                          updateImages(row.id);
                        }
                      }}
                    />
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  function ConfirmationAlert() {
    return (
      <React.Fragment>
        <Dialog
          open={openConfirmationAlert}
          onClose={handleAlertClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {localization.areYouSureYouWantToDelete}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {localization.setDefaultImageWarning}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleAlertClose}>{localization.cancel}</Button>
            <Button onClick={handleAlertOk} autoFocus>
              {localization.ok}
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }

  return (
    <>
      <React.Fragment>
        <Dialog
          fullWidth={fullWidth}
          maxWidth={"md"}
          open={open}
          onClose={handleClose}
        >
          <DialogTitle>
            {localization.manageImages}
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              {localization.organizeImages} #{sessionStorage.getItem("invnr")}
            </Typography>
            <div className="row p-4 justifyContentSpaceBetw">
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                {imageData.length} {localization.imagesAvailable}
              </Typography>

              <div>
                <Button
                  variant="outlined"
                  sx={{ textTransform: "none" }}
                  startIcon={<MdOutlineFileUpload />}
                  size="large"
                  onClick={() => {
                    setShowFileUploadDialog(true);
                  }}
                >
                  {localization.uploadNewImages}
                </Button>
              </div>
            </div>
          </DialogTitle>
          <DialogContent dividers>
            <div>
              <BasicTable />
            </div>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" size="large" onClick={handleClose}>
              {localization.close}
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
      {openConfirmationAlert && <ConfirmationAlert />}
    </>
  );
}
